<template>
  <div>
    <v-data-table
      dense
      sort-by="name"
      :mobile-breakpoint="0"
      :headers="headers"
      :itemsPerPage="User.length"
      show-expand
      :loading="isLoading"
      hide-default-footer
      :items="User"
    >
      <template v-slot:item="{ item }">
        <tr>
          <td class="text-left">
            <v-btn class="no-print" @click="toggleExpand(item)" icon>
              <v-icon v-if="expandedRow === item">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </td>

          <td class="text-left text-capitalize">
            <span v-if="item.Customer">{{ item.Customer.name }}</span>
            <span v-else>N/A</span>
          </td>
          <td class="text-right">
            {{ item.totalSale | currency }}
          </td>
        </tr>

        <!-- Conditionally render the expanded row -->
        <tr v-if="expandedRow === item">
          <td :colspan="headers.length" class="pa-0">
            <v-card color="#F3F8FC" flat>
              <v-card-text class="title">
                <Invoice
                  :CustomerId="item.CustomerId"
                  :start="start"
                  :end="end"
                />
              </v-card-text>
            </v-card>
          </td>
        </tr>
      </template>

      <template v-slot:body.append>
        <tr :style="{ 'background-color': $style.listTotal.filter }">
          <td></td>
          <td class="font-weight-bold">Total</td>
          <td class="text-right font-weight-bold">
            {{ totalReportSale | currency }}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
// import saleService from "@/modules/ReportView/service.js";
import invoiceService from "@/modules/Invoice/service";

const Invoice = () => import("@/modules/ReportView/GlobalReport/Invoice.vue");
export default {
  props: ["start", "reset", "end", "CustomerId"],
  name: "salesman-report",
  data() {
    return {
      isLoading: true,
      sortBy: "name",
      User: [],
      Category: [],
      expanded: [],
      expenseExpanded: [],
      expandedRow: null,
      headers: [
        { text: "", value: "data-table-expand" },
        {
          text: "NAME",
          align: "left",
          value: "name",
          sortable: true,
        },
        {
          text: "SALE",
          align: "right",
          value: "totalSale",
          sortable: true,
        },
      ],
      totalReportSale: 0,
    };
  },
  components: {
    Invoice,
  },
  async created() {
    await this.getCustomerSale();
  },

  methods: {
    toggleExpand(item) {
      this.expandedRow = this.expandedRow === item ? null : item;
    },
    color(item) {
      let value = "black";
      let profit = item.totalPrice - item.totalCost;
      if (profit < 0) {
        value = "red";
      }
      return value;
    },
    getCustomerSale() {
      // console.log("start", this.start);
      // console.log("end", this.end);
      let where = {};
      if (this.start) where.start = this.start;
      if (this.end) where.end = this.end;
      return invoiceService.invoiceByCustomer(where).then((result) => {
        // console.log("result invoice", result);
        this.User = result.data;
        this.User.map((row) => {
          this.totalReportSale += row.totalSale;
        });
        this.isLoading = false;
      });

      // return saleService.getSaleByCategory(where).then((response) => {
      //   this.Category = response.data;
      //   // // console.log('category', this.Category)
      //   this.Category.map((row) => {
      //     this.totalReportSale += row.totalPrice;
      //     this.totalReportCost += row.totalCost;
      //     let totalSale = this.totalReportSale - this.totalReportCost;
      //     this.$emit("fatchData", totalSale);
      //   });
      //   this.isLoading = false;
      // });
    },
  },
};
</script>

<style scoped></style>
